export const preloadImages = ( ...images: string[] ) => images.map( ( src ) => {
  const image = new Image()
  Object.assign( image, { src } )
  return image
} )

export default preloadImages
